<template>
  <v-data-table
    :headers="serviceHeaders"
    :items="dataservice"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    :search="searchservice"
    item-key="id_service_activity"
    show-expand
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar
        flat
        class="mt-5"
      >
        <v-toolbar-title>Data Service  {{ activity.company_name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchservice"
          solo
          dense
          append-icon="mdi-magnify"
          :label="'Search Service '+activity.company_name"
          class="mr-3 white"
          outlined
          hide-details
        />
          <v-dialog
          persistent
          v-model="dialog3"
          width="900"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="primary"
              v-bind="attrs"
              v-on="on"
            >
              Add New Service  <v-icon>{{ icons.mdiPlus }}</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h6 ">{{ formTitle }} {{ activity.company_name }}</span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <td colspan="5">
                          <v-text-field
                            v-model="formservice.service_name"
                            dense
                            hide-details
                            outlined
                            placeholder="Service Name"
                            label="Service Name"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td class="p-1">
                          <v-text-field
                            v-model="record.detail_activity"
                            hide-details
                            dense
                            outlined
                            placeholder="Detail Acitivity"
                            label="Detail Activity"
                          />
                        </td>
                        <td>
                          <v-currency-field
                            v-model="record.cost_for_adult"
                            prefix="Rp."
                            type="number"
                            hide-details
                            dense
                            outlined
                            placeholder="Cost For Adult"
                            label="Cost For Adult"
                          />
                        </td>
                        <td>
                          <v-currency-field
                            v-model="record.cost_for_child"
                            prefix="Rp."
                            type="number"
                            hide-details
                            dense
                            outlined
                            placeholder="Cost For Child"
                            label="Cost For Child"
                          />
                        </td>
                        <td>
                          <v-text-field
                            v-model="record.note"
                            hide-details
                            dense
                            outlined
                            placeholder="Note Service"
                            label="Note Service"
                          />
                        </td>
                        <td>
                          <v-btn
                            class="primary"
                            @click="AddRecord()"
                          >
                            Add <v-icon>{{ icons.mdiPlus }}</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(s,index) in formservice.details"
                        :key="s.detail_activity"
                      >
                        <td class="p-1">
                          <v-text-field
                            v-model="s.detail_activity"
                            hide-details
                            dense
                            outlined
                            placeholder="Detail Service"
                            label="Detail Service"
                          />
                        </td>
                        <td>
                          <v-currency-field
                            v-model="s.cost_for_adult"
                            hide-details
                            dense
                            outlined
                            placeholder="Cost For Adult"
                            label="Cost For Adult"
                          />
                        </td>
                        <td>
                          <v-currency-field
                            v-model="s.cost_for_child"
                            hide-details
                            dense
                            outlined
                            placeholder="Cost For Child"
                            label="Cost For Child"
                          />
                        </td>
                        <td>
                          <v-text-field
                            v-model="s.note"
                            hide-details
                            dense
                            outlined
                            placeholder="Note Service"
                            label="Note Service"
                          />
                        </td>
                        <td>
                          <v-btn
                            class="rd"
                            @click="DeleteService(index)"
                          >
                            Delete <v-icon>{{ icons.mdiTrashCan }}</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                class="text-capitalize"
                text
                @click="CekDialog()"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                class="text-capitalize"
                text
                @click="Save"
              >
                {{ TittleButton }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <v-row>
          <v-col>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>Notes</td>
                  <td>{{ item.note }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </td>
    </template>
    <template #[`item.cost_for_child`]="{ item }">
      Rp. {{ Number(item.cost_for_child).toLocaleString() }}
    </template>
    <template #[`item.cost_for_adult`]="{ item }">
      Rp. {{ Number(item.cost_for_adult).toLocaleString() }}
    </template>
    <template #[`item.actions`]="{ item }">
      <v-btn
        small
        class="mr-2 text-capitalize primary"
        @click="editItem(item)"
      >
        <v-icon>{{ icons.mdiPencil }}</v-icon>
      </v-btn>
      <v-btn
        small
        class="mr-2 text-capitalize primary"
        @click="deleteItem(item)"
      >
        <v-icon>{{ icons.mdiTrashCan }}</v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
} from '@mdi/js'
import axios from 'axios'

export default {
  props: ['activity'],
  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
      },
      modal1: false,
      modal2: false,
      dialog: false,
      dialog3: false,
      searchservice: '',
      expanded: [],
      editedIndex: -1,
      singleExpand: true,
      serviceHeaders: [
        { text: 'Detail Activity', value: 'detail_activity' },
        { text: 'Cost Child', value: 'cost_for_child' },
        { text: 'Cost Adult', value: 'cost_for_adult' },
        { text: 'Service Name', value: 'service_name' },

        {
          text: 'Actions', value: 'actions', sortable: false, width: 200,
        },
      ],
      record: {
        detail_activity: '',
        cost_for_adult: '',
        cost_for_child: '',
        note: '',
      },
      formservice: {
        service_name: '',
        id_activity: '',
        details: [],
      },
      dataservice: [],
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Service ' : 'Edit Service Activity'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Activity' : 'Update Activity'
    },
  },
  watch: {
    activity(newVal, oldVal) {
      if (newVal.id_activity !== oldVal.id_activity) {
        this.initialize()
        this.formservice.id_activity = newVal.id_activity
      }
    },
  },
  mounted() {
    this.initialize()
    this.formservice.id_activity = this.activity.id_activity
  },
  methods: {
    DeleteService(index) {
      this.formservice.details.splice(this.formservice.details.indexOf(index), 1)
    },
    AddRecord() {
      this.formservice.details.push(this.record)
      this.record = {
        detail_activity: '',
        cost_for_adult: '',
        cost_for_child: '',
        note: '',
      }
    },
    CekDialog() {
      this.formservice = {
        service_name: '',
        id_activity: this.activity.id_activity,
        details: [],
      }
      this.dialog3 = false
    },
    editItem(item) {
      this.editedIndex = this.dataservice.indexOf(item)
      this.formservice.service_name = item.service_name
      this.formservice.id_activity = item.id_activity
      this.formservice.details = item.details
      this.dialog3 = true
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/getServiceActivity', { id_activity: this.activity.id_activity }).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.dataservice = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteServiceActivity', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveServiceActivity', this.formservice).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog3 = false
        this.editedIndex = -1
        this.initialize()
        this.CekDialog()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
